import { ICellRendererParams } from 'ag-grid-community'

import { formatTimestamp } from '@/lib/date/date'

import type { ArtifactRow } from '@/pages/company-drawer/artifact/ag-grid-artifact/types'

export const ArtifactExpiryDateCell = ({ data }: ICellRendererParams<ArtifactRow>) => {
  if (!data?.expirationDate) return <span className='text-main-foreground-tertiary'>–</span>

  return (
    <span className='text-nowrap text-md font-light text-main-foreground-primary'>
      {formatTimestamp(data.expirationDate)}
    </span>
  )
}
